
import React from 'react';
import Layout from '@/components/Layout/Layout';
import TimeConverter from '@/components/UnitConverter/TimeConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TimeConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Time Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different units of time, from seconds to years and everything in between.
          </p>
        </div>
        
        <div className="mb-8">
          <TimeConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Time Converter</h2>
          <p>
            Our time converter tool helps you convert between different units of time measurement. 
            Time is a fundamental dimension used to sequence events, compare their durations, 
            and quantify rates of change. This converter supports a wide range of time units, 
            from microseconds to millennia.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Time Unit Conversions</h3>
          <p>
            Some of the most frequently used time conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between hours, minutes, and seconds</li>
            <li>Converting days to hours or weeks</li>
            <li>Converting years to days or months</li>
            <li>Converting between milliseconds and seconds (for computing and science)</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Time Converter</h3>
          <p>
            Using our time converter is straightforward:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the value you want to convert in the "From" field</li>
            <li>Select the time unit you're converting from</li>
            <li>Select the time unit you want to convert to</li>
            <li>The converted value will appear automatically</li>
          </ol>
          
          <p className="mt-6">
            The time converter supports a wide range of units, including nanoseconds, microseconds, 
            milliseconds, seconds, minutes, hours, days, weeks, months, years, decades, centuries, 
            and millennia. Whether you're working on scientific calculations, project planning, 
            or historical timelines, our converter provides accurate conversions between all common time units.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default TimeConverterPage;
